<template lang="pug">
    v-app(light)
        // Header
        div.header

            // Logo
            logo-component(type="dashboard")

            // Header menu
            header-navigation(
                :items="menuItems"
                :currentRoute="currentRoute"
                v-if="$vuetify.breakpoint.mdAndUp"
            )

            v-spacer

            // Profile section
            header-profile

            // Mobile menu
            mobile-navigation(:items="menuItems" :class="{isMember: isMember}" v-if="$vuetify.breakpoint.smAndDown")

        div.contentOuter(:class="{ 'mypractice' : ($route.name === 'dashboard.statistics.user' || $route.name === 'dashboard.journal' || $route.name === 'dashboard.timer') }")
            v-content.content
                div.contentWrapper(:class="{ 'contentErrorWrapper' : $route.name === 'dashboard.pageNotFound' }")
                    // keep-alive keeps the session view mounted across
                    // navigation so the Playerjs instance (and its audio)
                    // is preserved — lets the user return to an
                    // in-progress session mid-way.
                    keep-alive(include="SessionsViewPage")
                        router-view

                    suggested-session(v-if="showSuggestedSession" :handleClose="handleClose")

        // Waves background
        div.waves(v-if="$route.name === 'dashboard.help'")

        Footer(v-if="$vuetify.breakpoint.mdAndUp")

        // Prompt (confirmation popup)
        prompt-component

        // Agreement dialog
        //agreement-modal

        // Information dialog
        //information-modal
</template>

<script>
    import Button from '~components/Button';
    import Logo from '~components/Logo';
    import Prompt from '~components/Prompt';
    import Separator from '~components/Separator';
    import HeaderNavigation from './HeaderNavigation';
    import MobileNavigation from './MobileNavigation';
    import HeaderProfile from './HeaderProfile';
    import InformationModal from './InformationModal';
    import AgreementModal from './AgreementModal';
    import Footer from './Footer';
    import TrackView from '~services/TrackView';
    import {
        PushNotificationsNative,
        HealthIntegration,
        isNative
    } from '~services';
    import { mapActions, mapGetters } from 'vuex';
    import dayjs from 'dayjs';
    import events from '~api/events';
    import SuggestedSession from './SuggestedSession';

    const MENU_LIST = [
        {
            title: 'general.menu.sessions',
            link: '/themes',
            iconAlt: 'List',
            iconLink:
                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/navigation-icons/ico_meditation.svg',
            perm: ['admin', 'champion', 'instructor', 'member']
        },
        {
            title: 'general.menu.statistics',
            link: '/statistics',
            perm: ['admin', 'champion']
        },
        {
            title: 'general.menu.practice',
            link: '/my-practice',
            iconAlt: 'Graph',
            iconLink:
                'https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/navigation-icons/ico_practice.svg',
            perm: ['member']
        },
        {
            title: 'general.menu.managers',
            link: '/managers',
            perm: ['admin']
        },
        {
            title: 'general.menu.businesses',
            link: '/businesses',
            perm: ['admin']
        },
        {
            title: 'general.menu.users',
            link: '/users',
            perm: ['champion', 'admin']
        },
        {
            title: 'general.menu.goals',
            link: '/goals',
            perm: ['admin']
        },
        {
            title: 'general.menu.programs',
            link: '/programs',
            perm: ['admin']
        },
        {
            title: 'general.menu.pages',
            link: '/landing-pages',
            perm: ['admin']
        },
        {
            title: 'general.menu.coupons',
            link: '/coupons',
            perm: ['admin']
        },
        {
            title: 'general.menu.reports',
            link: '/reports/activity',
            perm: ['admin']
        },
        {
            title: 'general.menu.timer',
            link: '/timer',
            icon: 'timer',
            perm: ['member', 'admin', 'champion']
        },
        {
            title: 'general.menu.feed',
            link: '/feed',
            icon: 'dynamic_feed',
            perm: ['admin', 'champion', 'instructor', 'member']
        }
    ];

    const NOT_ALLOWED_PATH_FOR_WELCOME_VIDEO = [
        '/terms-and-conditions',
        '/privacy',
        '/sessions-with-subtitles',
        '/sessions-with-spanish-subtitles',
        '/sessions-with-ukrainian-subtitles',
        '/sessions-with-english-subtitles',
        '/sessions/view'
    ];

    const SHOW_SUGGESTED_SESSION_TIME = 3;
    const SHOW_SUGGESTED_SESSION_TIME_INTERVAL = 2;

    export default {
        components: {
            InformationModal,
            HeaderNavigation,
            MobileNavigation,
            HeaderProfile,
            AgreementModal,
            SuggestedSession,
            Footer,
            LogoComponent: Logo,
            PromptComponent: Prompt,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        data() {
            return {
                isAgreementDialog: false,
                showSuggestedSession: false,
                timeoutSuggestedSession: null,
                viewSuggestedSession: null,
                timeSuggestedSession: 0
            };
        },
        computed: {
            ...mapGetters('auth', [
                'user',
                'isMember',
                'isGoldman',
                'isAnthem',
                'isAwit'
            ]),
            ...mapGetters('modals', ['isWelcomeDialog']),

            currentRoute() {
                return this.$route.path;
            },

            allowWelcomeVideo() {
                const path = this.$router.currentRoute.path;

                return (
                    !NOT_ALLOWED_PATH_FOR_WELCOME_VIDEO.includes(path) &&
                    !NOT_ALLOWED_PATH_FOR_WELCOME_VIDEO.some(pathPart =>
                        path.includes(pathPart)
                    )
                );
            },

            /**
             * Return array of menu elements for Dashboard
             *
             * @returns {[]}
             */
            menuItems: function() {
                let self = this;
                let menu = [];

                const menuList = [...MENU_LIST];

                /**
                 * Check if isset element in Array
                 *
                 * @param arr
                 * @param obj
                 *
                 * @returns {boolean}
                 */
                function include(arr, obj) {
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i] == obj) return true;
                    }
                }

                menuList.forEach(function(elem) {
                    if (include(elem.perm, self.user.role)) {
                        menu.push(elem);
                    }
                });
                return menu;
            }
        },
        created() {
            const trackOptions = {
                userid: this.user.id,
                role: this.user.role,
                business: this.user.business ? this.user.business.name : 'Admin'
            };
            TrackView('user-login', trackOptions);

            // Web push: OneSignal only runs in real browsers. Native WebView
            // doesn't support service workers so we skip OneSignal there and
            // rely on PushNotificationsNative (AWS SNS) instead.
            if (
                !isNative() &&
                window.OneSignal &&
                typeof window.OneSignal.push === 'function'
            ) {
                window.OneSignal.push(() => {
                    window.OneSignal.setExternalUserId(this.user.id);
                    window.OneSignal.setEmail(this.user.email);
                    if (this.user.business) {
                        window.OneSignal.sendTag(
                            'business_name',
                            this.user.business.name
                        );
                    }
                });
            }

            // Native push: register this device's APNs / FCM token against the
            // authenticated user. No-op on web. The init happens once in
            // App.vue; here we flush the register after login completes.
            // Passing userId lets the service detect account switches and
            // force a re-POST so the backend reassigns the device from the
            // previous user to the current one.
            if (isNative()) {
                PushNotificationsNative.registerDevice({
                    userId: this.user.id
                }).catch(err =>
                    console.warn('[dashboard] device register failed', err)
                );

                // Health: warm up the permission cache + drain any pending
                // mindful-session writes that were queued while offline or
                // before the user granted permission.
                const health = new HealthIntegration();
                health
                    .isAvailable()
                    .then(available => {
                        if (available) return health.isAuthorized();
                        return false;
                    })
                    .then(() => health.flushPendingWrites())
                    .catch(() => {});
            }

            const viewPage = window.localStorage.getItem('todayPageView');
            this.viewSuggestedSession = window.localStorage.getItem(
                'todaySuggestedSessionView'
            );

            if (
                (viewPage === null ||
                    dayjs(viewPage).isBefore(dayjs(), 'day')) &&
                this.allowWelcomeVideo
            ) {
                window.localStorage.setItem('todayPageView', new Date());

                events.createEvent({ type: 'view_page' });
            }

            this.checkShowSuggestedSession();
        },
        beforeMount() {
            let showInformationDialogForMobile =
                this.$vuetify.breakpoint.smAndDown && isShowInformationDialog();

            /**
             * Check if localStorage was last time updated today or not.
             */
            function isShowWelcomeDialog() {
                return window.localStorage.getItem('welcomeDialog') === null;
            }

            /**
             * Check if show Information Dialog.
             */
            function isShowInformationDialog() {
                return (
                    window.localStorage.getItem('informationDialog') === null
                );
            }

            if (showInformationDialogForMobile) {
                // Show Information Dialog for Mobile Devices
                window.localStorage.setItem('informationDialog', new Date());
                this.setInformationDialog();
            } else if (isShowWelcomeDialog()) {
                // Show Welcome Dialog
                window.localStorage.setItem('welcomeDialog', new Date());
                this.setWelcomeDialog();
            }
        },
        methods: {
            ...mapActions('sessions', ['setCongratulationDialog']),
            ...mapActions('modals', [
                'setInformationDialog',
                'setWelcomeDialog'
            ]),
            handleClose() {
                this.showSuggestedSession = false;
            },
            checkShowSuggestedSession() {
                if (
                    (this.viewSuggestedSession === null ||
                        dayjs(this.viewSuggestedSession).isBefore(
                            dayjs(),
                            'day'
                        )) &&
                    !this.timeoutSuggestedSession
                ) {
                    this.timeoutSuggestedSession = setInterval(() => {
                        this.checkShowSuggestedSession();
                    }, SHOW_SUGGESTED_SESSION_TIME_INTERVAL * 1000);

                    return;
                }

                this.timeSuggestedSession =
                    this.timeSuggestedSession +
                    SHOW_SUGGESTED_SESSION_TIME_INTERVAL;

                if (
                    this.timeSuggestedSession > SHOW_SUGGESTED_SESSION_TIME &&
                    this.$router.currentRoute.name !== 'dashboard.sessions.view'
                ) {
                    this.showSuggestedSession = true;
                    window.localStorage.setItem(
                        'todaySuggestedSessionView',
                        new Date()
                    );
                    clearTimeout(this.timeoutSuggestedSession);
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_mixins.styl"
    @import "../../assets/style/_variables.styl";

    >>> .v-data-iterator__actions__pagination
        font-size: 16px
    >>> .v-data-iterator__actions__range-controls
        .v-btn
            width: 30px
            height: 30px
            background: rgba(255, 255, 255, 0.05)
        .v-btn__content .v-icon
            font-size: 24px

    .header
        display: flex
        height: 85px
        padding: 0 25px 0 20px
        border-bottom: 1px solid rgba(255, 255, 255, 0.3)
        align-items: center

    .contentWrapper
        height: 100%

    .mypractice
        background-image: url("https://s3.us-east-2.amazonaws.com/chillanywhere.com/assests/mypractice/background-min-2.png")
        background-position: center center;
        background-size: cover

    .contentOuter
        flex: 1 0 auto;
        max-width: 100%;

        .content
            background: $theme.primary
            min-height: 100vh

    .contentErrorWrapper
        display: flex
        align-items: center

    .waves
        width: 100%
        height: 300px
        background-image: url('../Authorization/Layout/images/background-min.jpg')
        background-size: cover
        background-repeat: no-repeat

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .header
            display: flex
            padding: 0 20px 0 10px
            height: 55px

        .profile_wrapper
            margin-top: 15px

        .waves
            height: 150px
</style>
